<template>
	<div class="grid">
		<template v-if="loader==true">
			<div class="col-12 mb-2 lg:col-12">
				<ProgressBar mode="indeterminate" style="height: .5em" />
			</div>
		</template>
		<!-- <div class="col-12">
			<h1>Opción 4</h1>
		</div> -->
		<!-- <div v-if="isRootPath" class="col-12 lg:col-12">
			<h4 class="mb-1">Seguridad</h4>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Usuarios
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('usuarios')"/>
					</template>
				</Toolbar>
			</div>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Perfiles
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('usuarios')" />
					</template>
				</Toolbar>
			</div>

			<h4 class="mb-1">Mobile</h4>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Conductores
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('usuarios')" />
					</template>
				</Toolbar>
			</div>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Eventos Logisticos
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('eventos')" />
					</template>
				</Toolbar>
			</div>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Pre Operacional
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('pesv')" />
					</template>
				</Toolbar>
			</div>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Tipo Gastos
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('tipo-gastos')" />
					</template>
				</Toolbar>
			</div>

			<h4 class="mb-1">Systram</h4>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Firma Manifiesto
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('eventos')" />
					</template>
				</Toolbar>
			</div>
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1 card">
					<template v-slot:start>
						Firma Clausulas
					</template>
					<template v-slot:end>
						<Button label="Ver" icon="pi pi-eye" :loading="loader" class="p-button-raised button-orange mr-2" @click="goTo('eventos')" />
					</template>
				</Toolbar>
			</div>
		</div> -->

		<!-- <div v-else class="col-12"> -->
		<!-- Aquí se carga la vista hija -->
			 <!-- <Breadcrumb :model="breadcrumbItems" class="mb-4" />
			<router-view />
		</div> -->


		<!-- NUEVO -->
		<!-- <div class="col-12">
			<h1>Opción 1</h1>
		</div> -->
		<!-- <div class="col-2">
			<Menu :model="menuitems" :style="{'height':'100%'}" class="custom-menu" />
		</div> -->
		<!-- <div class="col-10">
			<router-view/> 
		</div> -->

		<!-- <div class="col-12">
			<h1>Opción 2</h1>
		</div> -->
		<!-- <div class="col-2">
			<PanelMenu :model="menuitems" />
		</div> -->
		<div class="col-12">
			<router-view/> 
		</div>
		<!-- viejo -->
		<!-- <div class="col-12">
			<h1>Opción 3</h1>
		</div> -->
		<!-- <div class="col-12">
			<TabView v-model="activeIndex" class="p-tabview-vertical">
				
				<TabPanel header="Seway-App">
					<TabView v-model="activeIndexSeway" class="mt-4" @tab-click="handleTabChange">
						<TabPanel header="Eventos Logisticos">
							<EventosEntregas />
						</TabPanel>
						<TabPanel header="Configuración PESV">
							<ConfigPesv />
						</TabPanel>
						<TabPanel header="Tipo Gastos">
							<TipoGastos />
						</TabPanel>
					</TabView>
				</TabPanel>
				<TabPanel header="Systram">
					<TabView v-model="activeIndexSystram" class="mt-4">
						<TabPanel header="Firma Manifiesto">
						</TabPanel>
						<TabPanel header="Firma Clausula">
						</TabPanel>
					</TabView>
				</TabPanel>
				<TabPanel header="Seguridad">
					<TabView v-model="activeIndexSeguridad" class="mt-4">
						<TabPanel header="Usuarios">
						</TabPanel>
						<TabPanel header="Perfiles">
						</TabPanel>
					</TabView>
				</TabPanel>
			</TabView>
		</div> -->


	</div>
</template>

<script>
import EventBus from '../../event-bus';
import PanelMenu from 'primevue/panelmenu';
import EventosEntregas from './configuraciones/eventos.vue'
import TipoGastos from './configuraciones/TipoGastos.vue'
import ConfigPesv from './configuraciones/ConfigPesv.vue'
import Breadcrumb from 'primevue/breadcrumb';
export default {
	data() {
		return {
			activeIndex: 0,
            NameCustomer: this.$store.getters['infoNavigation/NameCustomer'],
            activeIndexSeway: 0,
            activeIndexSystram: 0,
			activeIndexSeguridad: 0,
            tabClicked: false,
			loader: false,
            modalAmplio: '1100px',
            modalResponsive: '90vw',
			menuitems: [
				{
					label:'Administración',
					items:[
						{
							label:'Usuarios',
							icon:'pi pi-fw pi-fw pi-users',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/usuarios'
						},
						{
							label:'Perfiles',
							icon:'pi pi-fw pi-bookmark-fill',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/usuarios'
						},

					]
				},
				{
					label:'Mobile',
					items:[
						{
							label:'Eventos Logisticos',
							icon:'pi pi-fw pi-fw pi-history',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/eventos'
						},
						{
							label:'Configuración PESV',
							icon:'pi pi-fw pi-calendar',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/pesv'
						},
						{
							label:'Tipo Gastos',
							icon:'pi pi-fw pi-wallet',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/tipo-gastos'
						},

					]
				},
				{
					label:'Firmas',
					items:[
						{
							label:'Firma Manifiesto',
							icon:'pi pi-fw pi-fw pi-pencil',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/eventos'
						},
						{
							label:'Firma Clausula',
							icon:'pi pi-fw pi-pencil',
							to: this.$store.getters['infoNavigation/Rol']+'/configuracion/pesv'
						}

					]
				}
			],
		}
	},
	mounted(){
		// this.cargar_empresas();
		// this.pieDataSaldos = this.getPieData();
	},
	methods:{
        handleTabChange(event) {
            console.log('Cambiaste de TabPanel. Nuevo índice activo:', event.index);

            switch (event.index) {
                case 0:
                    console.log('aaa');
                    
                    break;
                case 1:
                    EventBus.emit('traer-inspeccion');
                    // EventBus.emit('show-container',response.data.rol);
                    break;
                case 2:
                    EventBus.emit('traer-tipo-gastos');
                    // EventBus.emit('show-container',response.data.rol);
                    break;
                default:
                    break;
            }
        },
		salirCustomer(){
			this.ingresoCostumer = false;
		},
		goToUsuarios() {
			const ruta = this.$store.getters['infoNavigation/Rol'] + '/configuracion/usuarios';
			this.$router.push(ruta);
		},
		goTo(subruta) {
			const rolPath = this.$store.getters['infoNavigation/Rol']; // <- aquí accedes directamente
			const path = `${rolPath}/configuracion/${subruta}`;
			this.$router.push(path);

			// Breadcrumb dinámico
			this.breadcrumbItems = [
			{ label: 'Configuración', to: `${rolPath}/configuracion` },
			{ label: subruta.charAt(0).toUpperCase() + subruta.slice(1) }
			];
		},

	},
	computed: {
		isRTL() {
			return this.$appState.RTL;
		},
		breadcrumbItems() {
			const path = this.$route.path;
			const base = this.$store.getters['infoNavigation/Rol'];

			// Ruta exacta de configuración
			if (path === `${base}/configuracion`) {
				return [{ label: 'Configuración' }];
			}

			// Subruta dentro de /configuracion/*
			if (path.startsWith(`${base}/configuracion/`)) {
				const subruta = path.replace(`${base}/configuracion/`, '');

				// Opcional: diccionario para mostrar nombres más amigables
				const labelMap = {
					'usuarios': 'Usuarios',
					'eventos': 'Eventos',
					'pesv': 'PESV',
					'firma-clausulas': 'Firma de Cláusulas',
					'webhooks': 'Webhooks',
					// agrega más si lo necesitas
				};

				// Si existe en el diccionario, lo usa, si no, capitaliza la subruta
				const label = labelMap[subruta] || subruta.charAt(0).toUpperCase() + subruta.slice(1);

				return [
					{ label: 'Configuración', to: `${base}/configuracion` },
					{ label }
				];
			}

			// Fallback si no es una ruta conocida
			return [{ label: 'Inicio' }];
		},
		isRootPath() {
			const basePath = this.$store.getters['infoNavigation/Rol'];
			return this.$route.path === `${basePath}/configuracion`;
		},
	},
    components: {
        'EventosEntregas': EventosEntregas,
        'TipoGastos': TipoGastos,
        'ConfigPesv': ConfigPesv,
		Breadcrumb,
		PanelMenu
    }
}
</script>

<style scoped>
.modal-content {
  display: flex;
  justify-content: center;
}
</style>
